import request from '@/utils/request'

let Tuiguang_areaApi = {

  /*推广地区列表*/
  list(data) {
    return request._post('/shop/plus.tuiguang_area.Index/index', data);
},
/*添加推广地区*/
add(data) {
    return request._post('/shop/plus.tuiguang_area.Index/add', data);
},
/*修改推广地区*/
edit(data) {
    return request._post('/shop/plus.tuiguang_area.Index/edit', data);
},
/*删除推广地区*/
del(data) {
    return request._post('/shop/plus.tuiguang_area.Index/del', data);
},
/*推广地区详情*/
detail(data) {
  return request._post('/shop/plus.tuiguang_area.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.tuiguang_area.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.tuiguang_area.Setting/getSetting', data, errorback);
    },
}
export default Tuiguang_areaApi;



// WEBPACK FOOTER //
// ./src/api/tuiguang_area.js